<template>
  <div class="card-body">
    <h4 id="header-shipment" class="card-title card-collapse">
      <span class="pointer" @click="onClickCollapse">Shipment Detail</span>
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="shipmentComponentModel.validateState == false"
          @click="
            shipmentComponentModel.collapseState =
              !shipmentComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button class="btn-icon-collapse" @click="onClickCollapse">
          <template>
            <i
              v-if="shipmentComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-shipment"
      v-model="shipmentComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div
                class="form-row"
                v-if="
                  userInfo.user_type === 'Operator' ||
                  (userInfo.user_type === 'Vendor' &&
                    vendor_type === 'OFMStock')
                "
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >ระยะเวลาในการขนส่ง</label
                >
                <div class="col-sm-3 col mt-auto mb-auto">
                  <div class="relative form-group inline-icon">
                    <input
                      disabled
                      type="text"
                      class="form-control text-right"
                      :value="lead_time"
                    />
                    <i
                      class="bx bx-info-circle text-grey ml-2 f-18"
                      id="tooltip-shipment"
                    />
                    <b-tooltip
                      target="tooltip-shipment"
                      placement="right"
                      variant="info"
                      >Lead Time ระยะเวลาที่ผู้ขายจัดส่งสินค้าให้กับ Officemete
                    </b-tooltip>
                  </div>
                </div>
              </div>
              <div
                class="form-row"
                v-if="
                  userInfo.user_type === 'Operator' ||
                  (userInfo.user_type === 'Vendor' &&
                    vendor_type === 'DropShip')
                "
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >ระยะเวลาในการจัดส่ง</label
                >
                <div class="col-sm-3">
                  <validationProvider
                    v-slot="{ errors }"
                    name="delivery"
                    :rules="
                      is_free ? {} : { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                    "
                    class="relative d-block form-group inline-icon"
                  >
                    <multiselect
                      v-model="shipmentComponentModel.model.delivery_time"
                      :options="options_delivery"
                      :class="{ 'is-invalid': is_free ? 0 : errors.length }"
                      :show-labels="false"
                      :disabled="
                        dataPermissions.find((f) => f.name === 'shipment')
                          .isEditable === false
                      "
                      placeholder="กรุณาเลือกระยะเวลาในการจัดส่ง"
                    />
                    <i
                      class="bx bx-info-circle text-grey ml-2 f-18"
                      id="tooltip-delivery"
                    />
                    <b-tooltip
                      target="tooltip-delivery"
                      placement="right"
                      variant="info"
                      >Delivery Time
                      ระยะเวลาที่ผู้ขายส่งสินค้าให้กับลูกค้า</b-tooltip
                    >
                    <span
                      v-if="errors.length"
                      class="validate-invalid"
                      style="bottom: 0px !important"
                    >
                      {{ is_free ? '' : errors[0] }}
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div
                class="form-row mb-3"
                v-if="
                  product_status &&
                  product_status === 'PreOrder' &&
                  vendor_type &&
                  vendor_type === 'OFMStock'
                "
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >วันที่เริ่มจัดส่งสินค้า</label
                >
                <div class="col-sm-3">
                  <validationProvider
                    v-slot="{ errors }"
                    name="delivery_start_date"
                    class="relative d-flex form-group inline-icon"
                  >
                      <date-picker
                        placeholder="เลือกวันที่"
                        class="mx-date-tooltip"
                        v-model="date_delivery"
                        :type="'date'"
                        lang="en"
                        :format="'DD/MM/YYYY'"
                        confirm
                        :class="{ 'is-invalid': errors.length }"
                        :disabled="
                        dataPermissions.find((f) => f.name === 'shipment')
                          .isEditable === false
                      "
                        @change="onSelectDate(date_delivery)"
                      />
                        <i
                          class="bx bx-info-circle text-grey f-18 float ml-2 pt-2"
                          id="tooltip-delivery_start_date"
                        />
                        <b-tooltip
                          target="tooltip-delivery_start_date"
                          placement="right"
                          variant="info"
                          >ระยะเวลาที่ผู้ขายสามารถเริ่มจัดส่งสินค้าให้กับลูกค้า</b-tooltip
                        >
                    
                    <span
                      v-if="errors.length"
                      class="validate-invalid"
                      style="bottom: 0px !important"
                    >
                      {{errors[0] }}
                    </span>
                  </validationProvider>
                </div>
              </div>
            </div>
          </div>
          <table-dimension
            :skus="skus"
            :requestDocumentInformation="requestDocumentInformation"
            :inventoryId="inventoryId"
            :vendor_type="vendor_type"
            :is_free="is_free"
            :is_view="is_view"
            v-model="shipmentComponentModel.model.dimensions"
          />
        </div>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import TableDimension from '@/components/product-register/table-dimension'
import { getUserInfo } from '@/helpers/utils/jwt'
import { authComputed } from '@/state/helpers'
import { eventBus } from '@/main.js'
import DatePicker from 'vue2-datepicker'
import { ToISOString } from '@/helpers/utils/format-date.js'
export default {
  name: 'Shipment',
  components: { Multiselect, 'table-dimension': TableDimension, DatePicker },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.shipmentComponentModel
      },
    },
    skus: {
      type: Array,
      default: () => [],
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    lead_time: {
      type: Number,
      default: () => {
        return 0
      },
    },
    inventoryId: {
      type: String,
      default: () => {
        return ''
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      options_attributsets: [],
      options_delivery: ['1-3', '3-7', '7-15', '15-30', '30-45', '45-90'],
      shipmentComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          delivery_time: '',
          dimensions: [],
        },
      },
      permissions: [
        {
          name: 'shipment',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      date_delivery: '',
      product_status: '',
    }
  },
  created() {
    eventBus.$on('collapse-shipment', (text) => {
      this.shipmentComponentModel.collapseState = true
      this.onSubmit()
    })
    eventBus.$on('setShipmentOptionForDropShip', () => {
      this.options_delivery = ['3-7', '7-15', '15-30', '30-45', '45-90']
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter((f) => f.my_process_action.can_edit === true)
          .map((m) => m.rule_id)

        permissions
          .filter((f) =>
            f.ruleIDs.some((s) => ruleEditables.some((r) => r === s))
          )
          .forEach((element) => {
            element.isEditable = true
          })
      } else {
        permissions.forEach((element) => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },
  watch: {
    value: {
      handler(val) {
        this.shipmentComponentModel = val
        if(this.shipmentComponentModel.model.delivery_start_date && this.shipmentComponentModel.model.delivery_start_date != "0001-01-01T00:00:00Z"){
          this.date_delivery = new Date(this.shipmentComponentModel.model.delivery_start_date)
        }
        this.$nextTick(() => {
          this.onSubmit()
        })
      },
      deep: true,
    },
    'shipmentComponentModel.model.dimensions': {
      handler() {
        this.onSubmit()
      },
      deep: true,
    },
    skus: {
      handler(val) {
        if (val && val.length > 0) {
          this.product_status = val[0].skuModel.product_status.inventory
        }
      },
      deep: true,
    },
  },
  methods: {
    async onSelectDate(date) {
      if (date) {
        date = new Date(date).toLocaleString('en-US', {
          timeZone: 'Asia/Bangkok',
        })
        this.shipmentComponentModel.model.delivery_start_date = ToISOString(date)
      }
    },
    modelChanged() {
      this.shipmentComponentModel.isPayloadChanged = true
      this.$emit('input', this.shipmentComponentModel)
    },
    onClickCollapse() {
      if (this.skus && this.skus.length > 0) {
        this.shipmentComponentModel.collapseState =
          !this.shipmentComponentModel.collapseState
      } else {
        setTimeout(function () {
          document.getElementById('header-product-detail').scrollIntoView({
            block: 'center',
            behavior: 'smooth',
          })
          eventBus.$emit('collapse-product-detail', true)
        }, 500)
      }
    },
    onSubmit() {
      this.$refs.componentForm.validate().then((result) => {
        if (
          result &&
          this.checkValidateDimensions(
            this.shipmentComponentModel.model.dimensions
          )
        ) {
          this.shipmentComponentModel.validateState = true
        } else {
          this.shipmentComponentModel.validateState = false
        }
        this.modelChanged()
      })
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
    checkValidateDimensions(val) {
      if (val && val.length === 0) {
        return false
      } else if (
        val.some((s) => s.width_size_value === '' || s.width_size_value <= 0)
      ) {
        return false
      } else if (
        val.some((s) => s.length_size_value === '' || s.length_size_value <= 0)
      ) {
        return false
      } else if (
        val.some((s) => s.height_size_value === '' || s.height_size_value <= 0)
      ) {
        return false
      } else if (val.some((s) => s.size_type === '')) {
        return false
      } else if (
        val.some((s) => s.weight_value === '' || s.weight_value <= 0)
      ) {
        return false
      } else if (val.some((s) => s.weight_type === '')) {
        return false
      } else {
        return true
      }
    },
  },
}
</script>
